import { createFileRoute } from '@tanstack/react-router';
import { JourneysSegmentUsageHandoff } from '@/pages/workspaces/segments/[segmentId]/usage/routing';

/**
 * The `journeys` URL the embedded app's segment tab bar links to for Usage. It forwards to the
 * tab's own URL with the sentinel kept, and that route resolves it. So no resolver runs here.
 */
function JourneysSegmentUsageRoute() {
  const { segmentId } = Route.useParams();

  return <JourneysSegmentUsageHandoff segmentId={segmentId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/usage')({
  component: JourneysSegmentUsageRoute,
});
